import React, { useState } from "react";
import FileUpload from "../FileUploader/FileUpload";
import FileList from "../FileUploader/FileList";
import RichTextEditor from "../RichTextEditor";
import { faTrashCan } from "@fortawesome/free-regular-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faFileAlt,
  faSpinner,
  faTrash,
} from "@fortawesome/free-solid-svg-icons";
import axios from "axios";
import Loading from "../Loading";
import { faCircleExclamation } from "@fortawesome/free-solid-svg-icons";
import NetworkError from "./NetworkError";
import Swal from "sweetalert2";
import RolesCheckboxes from "../RolesCheckboxes";
import { normalizeRoles, primaryRole } from "../../utils/roles";
function NewUser({ setShowModal, users, setUsers }) {
  const [showError, setShowError] = useState(false);
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(false);
  const [values, setValues] = useState({
    password: "",
    email: "",
    roles: [],
  });
  const changeHandler = (e) => {
    setValues({ ...values, [e.target.name]: e.target.value });
  };

  const submitUser = (e) => {
    e.preventDefault();
    const roles = normalizeRoles(values.roles);
    if (values.email !== "" && roles.length !== 0 && values.password !== "") {
      setError(null);
      setLoading(true);
      axios
        .post(`${"https://api.sedihisham.com"}/auth/user/signup`, {
          email: values.email,
          role: primaryRole(roles),
          roles: roles,
          password: values.password,
        })
        .then(function (response) {
          setLoading(false);
          setUsers([
            ...users,
            {
              id: response.data?.[1],
              email: values.email,
              role: primaryRole(roles),
              roles: roles,
            },
          ]);
          setShowModal(false);
          Swal.fire({
            icon: "success",
            title: "Your changes had been saved",
            showConfirmButton: false,
            timer: 1500,
          });
        })
        .catch(function (error) {
          console.log(error);
          setLoading(false);
          if (error.code === "ERR_NETWORK") {
            setShowError(true);
            setTimeout(() => {
              setShowError(false);
            }, 3000);
          } else {
            setError(
              error.response?.data?.message || "Could not add the user"
            );
          }
        });
    } else {
      setError("Please fill all required fields and select at least one role");
    }
  };

  return (
    <>
      <div className="justify-center items-center flex overflow-x-hidden overflow-y-auto fixed inset-0 z-50 outline-none focus:outline-none">
        <div className="relative my-6 w-[85%]">
          <form onSubmit={submitUser}>
            <div className="border-0 rounded-xl shadow-lg relative flex flex-col w-full bg-white outline-none focus:outline-none">
              <div className="flex justify-between h-[50px]  rounded-t">
                <div className="text-[18px] w-[20%] text-center m-auto  font-semibold">
                  Add New Admin User
                </div>
                <div className="w-[80%] rounded-bl-xl rounded-tr-xl bg-[#E9F6FD] h-full"></div>
              </div>
              {/* {body} */}
              <div className="relative p-6 w-full ">
                <div className="w-[90%]">
                  <div className="flex justify-between ">
                    <label
                      className="text-[14px] mr-4 font-[400]"
                      htmlFor="email"
                    >
                      Email
                    </label>
                    <input
                      required
                      className="w-[90%] h-[30px] rounded border-[#c4c8cf] placeholder:text-[center] placeholder:text-[12px] placeholder:font-[400]"
                      placeholder="Enter email"
                      onChange={changeHandler}
                      value={values.email}
                      name="email"
                      type="email"
                      id="email"
                    />
                  </div>
                  <div className="flex justify-between mt-6">
                    <label
                      className="text-[14px] mr-4 font-[400]"
                      htmlFor="password"
                    >
                      Password
                    </label>
                    <input
                      required
                      className="w-[90%] h-[30px] rounded border-[#c4c8cf] placeholder:text-[center] placeholder:text-[12px] placeholder:font-[400]"
                      placeholder="Enter user name"
                      onChange={changeHandler}
                      value={values.password}
                      name="password"
                      type="password"
                      id="password"
                    />
                  </div>
                  <div className="flex justify-between mt-6">
                    <label className="text-[14px] mr-4 font-[400]">Roles</label>
                    <div className="w-[90%]">
                      <RolesCheckboxes
                        selected={values.roles}
                        onChange={(roles) => setValues({ ...values, roles })}
                      />
                    </div>
                  </div>
                </div>
              </div>

              {error ? (
                <p className="text-[14px] ml-4 font-[400] mt-8 text-[red]">
                  <FontAwesomeIcon icon={faCircleExclamation} /> {error}
                </p>
              ) : null}
              {/*footer*/}
              <div className="flex items-center justify-end p-3 rounded-b">
                <div className=" flex pb-[10px] ">
                  <div
                    onClick={() => setShowModal(false)}
                    className="rounded-full cursor-pointer text-[13px] mr-2 px-6 py-1 text-[#0388CC] bg-[#E9F6FD]"
                  >
                    Cancel
                  </div>
                  <input
                    type="submit"
                    className="cursor-pointer rounded-full text-[13px] px-6 py-1 text-[#fff] bg-[#0388CC]"
                    value="Save"
                  />
                </div>
              </div>
            </div>
          </form>
        </div>
      </div>
      {loading ? <Loading /> : null}
      {showError ? <NetworkError setShowModal={setShowError} /> : null}
      <div className="opacity-25 fixed inset-0 z-40 bg-black"></div>
    </>
  );
}

export default NewUser;
